import React from "react";

export function BookIllustration({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`book-illustration ${compact ? "book-illustration--compact" : ""}`} aria-hidden="true">
      <div className="book-illustration__glow" />
      <div className="book-illustration__stars">
        <i>✦</i><i>·</i><i>✧</i><i>·</i>
      </div>
      <div className="book-illustration__book">
        <div className="book-illustration__page book-illustration__page--left" />
        <div className="book-illustration__page book-illustration__page--right" />
        <div className="book-illustration__road">N</div>
        <div className="book-illustration__goal">✦</div>
      </div>
      <div className="book-illustration__base" />
    </div>
  );
}
